import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

import { Button } from './form-inputs';
import { _Object } from 'utils/interfaces';
import { getFilteredLabel } from 'utils';

type Props = {
  filterdLabel: _Object;
  setFilteredLabel: any;
  setFilterData: any;
  filterData?: any;
  setFilterApply?: any
};

const TOP_LEVEL_KEYS = ['start_date', 'end_date', 'sort'];

const ActiveFilters = (props: Props) => {
  const { filterdLabel, setFilteredLabel, setFilterData, filterData, setFilterApply } = props;

  const toArray = (val: any): any[] => {
    if (!val) return []
    if (Array.isArray(val)) return val

    if (typeof val === 'string') {
      const str = val.trim()
      if (!str) return []

      const isDateLike = /^[A-Za-z]{3,}\s+\d{1,2},\s*\d{4}$/.test(str)
      if (isDateLike) return [str]

      return str
        .split(',')
        .map((x) => x.trim())
        .filter(Boolean)
    }

    return [val]
  }

  const removeMultipleItem = (keyToRemove: string, index: number) => {
    // ✅ multi values only supported inside filter object
    const ids = toArray(filterData?.filter?.[keyToRemove]);
    const labels = toArray(filterdLabel?.[keyToRemove]);

    const updatedIds = ids.filter((_: any, i: number) => i !== index);
    const updatedLabels = labels.filter((_: any, i: number) => i !== index);

    setFilterData((prev: any) => ({
      ...prev,
      filter: {
        ...prev.filter,
        [keyToRemove]: updatedIds,
      },
    }));

    setFilteredLabel((prev: any) => {
      if (updatedLabels.length === 0) {
        const copy = { ...prev };
        delete copy[keyToRemove];
        return copy;
      }

      return {
        ...prev,
        [keyToRemove]: updatedLabels,
      };
    });
    setFilterApply((prev: boolean) => !prev);
  };

  const removeSingleFilter = (keyToRemove: string) => {
    if (TOP_LEVEL_KEYS.includes(keyToRemove)) {
      console.log('keyToRemove :>> ', keyToRemove);
      setFilterData((prev: any) => {
        const updated = { ...(prev || {}) }   // ✅ shallow copy is enough
        delete updated[keyToRemove]           // ✅ remove direct key
        return updated
      })

      setFilteredLabel((prev: any) => {
        const copy = { ...(prev || {}) }
        delete copy[keyToRemove]
        return copy
      })

      setFilterApply((prev: boolean) => !prev)
    }else{
      setFilterData((prev: any) => {
        const updated = { ...(prev.filter || {}) };
        delete updated[keyToRemove];

        return {
          ...prev,
          filter: updated,
        };
      });

      setFilteredLabel((prev: any) => {
        const updated = { ...(prev || {}) };
        delete updated[keyToRemove];
        return updated;
      });
      setFilterApply((prev: boolean) => !prev);
    }
    return;
  };

  const hasFilters = filterdLabel && Object.entries(filterdLabel).length > 0;

  return (
    <ul className="list-inline mb-0 order-button-list ms-2">
      {hasFilters && <strong>Fillters&nbsp;&nbsp;</strong>}
      {hasFilters &&
        Object.entries(filterdLabel).map(([key, value]: any) => {
          const items = toArray(value);

          if (items.length > 1 && !TOP_LEVEL_KEYS.includes(key)) {
            return (
              <React.Fragment key={key}>
                <li className="list-inline-item text-capitalize">
                  <strong>{getFilteredLabel(key)}s:</strong>
                </li>

                {items.map((item: string, i: number) => (
                  <li className="list-inline-item" key={`${key}-${i}`}>
                    <span className="order-button">
                      <span>{item}&nbsp;</span>
                      <Button
                        className="ms-1 text-capitalize "
                        onClick={() => removeMultipleItem(key, i)}
                      >
                        <FontAwesomeIcon icon={faXmark} className="me-0 me-0 clone-buton-list" />
                      </Button>
                    </span>
                  </li>
                ))}
              </React.Fragment>
            );
          }

          return (
            <li className="list-inline-item" key={key}>
              <span className="order-button">
                <span>{getFilteredLabel(key)}:&nbsp;{items[0]}&nbsp;</span>
                <Button className="text-capitalize" onClick={() => removeSingleFilter(key)}>
                  <FontAwesomeIcon icon={faXmark} className="me-0 clone-buton-list" />

                </Button>
              </span>
            </li>
          );
        })}

      {hasFilters && (
        <li className="list-inline-item">
          <Button
            onClick={() => {
              setFilterData((e: _Object) => ({
                ...e,
                sort: '-created_at',
                start_date: '',
                end_date: '',
                filter: {},
              }));
              setFilteredLabel({});
              setFilterApply((prev: boolean) => !prev);
            }}
            className="transparent border-0 text-danger p-0 text-decoration-underline text-capitalize"
            name={Object.entries(filterdLabel).length === 1 ? 'Clear' : 'Clear all'}
          />
        </li>
      )}
    </ul>
  );
};

export default ActiveFilters;
